<template>
    <div class="custom-perfect-scrollbar">
        <VuePerfectScrollbar>
            <slot></slot>
        </VuePerfectScrollbar>
    </div>
</template>

<script>
    import VuePerfectScrollbar from 'vue-perfect-scrollbar';

    export default {
        components: {
            VuePerfectScrollbar
        },
    }
</script>

<style  lang="stylus" type="text/stylus">
    .custom-perfect-scrollbar
        .ps:hover > .ps__scrollbar-y-rail
            opacity 1
        .ps__scrollbar-y-rail
            background-color: #eee!important
            border-radius: 8px!important
            width: 15px!important
            right: 5px
            opacity: 1
        .ps__scrollbar-y
            border-radius: 8px!important
            width: 15px!important
            right: 0!important
</style>